import { indexEntries } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function KeywordIndex() {
  return (
    <section id="index" className="w-full border-b border-foreground-900/10 bg-background-50">
      <div className="mx-auto w-full max-w-[1360px] px-4 py-16 md:px-8 md:py-24">
        <SectionHeading
          index="04"
          kicker="速查索引"
          title="像查书末索引一样找入口"
          align="center"
          description="不想一本一本翻的时候，直接从这里按条目跳转；每条都标了收录量和它最擅长的方向。"
        />

        <div className="mt-12 grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-foreground-900/10 bg-foreground-900/10 sm:grid-cols-2 lg:grid-cols-3">
          {indexEntries.map((entry, index) => (
            <a
              key={entry.id}
              href="#collections"
              className="group flex cursor-pointer flex-col justify-between gap-7 bg-background-50 p-6 transition-colors hover:bg-accent-50 md:p-7"
            >
              <span className="font-heading text-sm font-bold text-accent-600">
                {String(index + 1).padStart(2, "0")}
              </span>
              <div>
                <h3 className="font-heading text-xl text-foreground-950 transition-colors group-hover:text-primary-700">
                  {entry.label}
                </h3>
                <p className="mt-2 text-sm text-foreground-600">{entry.hint}</p>
              </div>
              <div className="flex items-center justify-between border-t border-foreground-900/10 pt-4">
                <span className="text-xs text-foreground-500">{entry.count}</span>
                <span className="flex h-7 w-7 items-center justify-center rounded-full border border-foreground-900/15 text-foreground-700 transition-colors group-hover:border-primary-400 group-hover:text-primary-600">
                  <i className="ri-arrow-right-up-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}